module.exports = __webpack_public_path__ + "static/media/month.d050764b.svg";